import { notEmpty, not } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { belongsTo } from 'ember-data/relationships';
import DeliveryModel from 'cio/models/delivery';
import EnvironmentService from 'cio/services/environment';
import { Header } from 'cio/utils/models/header';

export default class DeliveryDetailModel extends Model {
  @service environment!: EnvironmentService;

  @attr('string') from!: string;
  @attr('string') replyTo!: string;
  @attr('string') bcc!: string;
  @attr('string') recipient!: string;
  @attr('string') subject!: string;
  @attr('string') preheaderText!: string;
  @attr('string') body!: string;
  @attr('boolean') selfSigned!: boolean;
  @attr('array') errorMessages!: unknown[];

  @attr('boolean') holdout!: boolean;

  @attr('boolean') customerDeleted!: boolean;
  @attr('boolean') hideBody!: boolean;

  @attr('string') requestMethod!: string;
  @attr({ defaultValue: () => [] }) headers!: Header[];
  @attr('string') url!: string;
  @attr('string') imageUrl!: string;

  @belongsTo('delivery', { async: false, inverse: 'detail' }) delivery!: DeliveryModel;

  @notEmpty('replyTo') hasReplyTo!: boolean;
  @notEmpty('bcc') hasBcc!: boolean;
  @notEmpty('errorMessages') hasErrorMessages!: boolean;

  @computed('from')
  get fromIdentity() {
    let { from } = this;

    /*
     * It's possible to have identities in the store from more than one workspace at once
     * Identities from different workspaces can have the same "address"
     * Looking-up based on current workspace instead of whole store makes sure identity from other workspace is never used
     */
    return this.environment.current.identities.findBy('address', from);
  }

  @computed('replyTo')
  get replyToIdentity() {
    let { replyTo } = this;
    return this.environment.current.identities.findBy('address', replyTo);
  }

  @not('delivery.hasError') readyToSend!: boolean;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'delivery-detail': DeliveryDetailModel;
  }
}
